
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire001c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire001c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1FxTl", function(module, exports) {

$parcel$export(module.exports, "arcade", () => $1373e8fb862fbfa8$export$11e8552c3b8a3d33);
$parcel$export(module.exports, "bindPointer", () => $1373e8fb862fbfa8$export$7e9d9e3ec42ce160);

var $cuPh8 = parcelRequire("cuPh8");
const $1373e8fb862fbfa8$export$11e8552c3b8a3d33 = {
    paused: false,
    muted: (0, $cuPh8.readSaved)('arcade-muted') === 'true',
    get soundEnabled () {
        return !this.muted && !this.paused;
    },
    mount ({ title: title, help: help, active: active, clearInput: clearInput, restart: restart, retryLevel: retryLevel = null, onResume: onResume = ()=>{} }) {
        const canvas = document.querySelector('canvas');
        canvas.tabIndex = 0;
        canvas.setAttribute('aria-label', `${title} playfield. ${help}`);
        canvas.textContent = `${title} needs a browser with canvas support.`;
        const bar = document.createElement('nav');
        bar.className = 'arcade-toolbar';
        bar.setAttribute('aria-label', 'Arcade controls');
        bar.innerHTML = `<a href="../index.html#arcade">\u{2039} Arcade lobby</a>
      <div class="arcade-tools"><button type="button" id="arcade-pause">Pause (P)</button>
      <button type="button" id="arcade-sound" aria-pressed="false">Sound</button>
      <button type="button" id="arcade-fullscreen">Full screen</button>
      <button type="button" id="arcade-help">How to play</button></div>`;
        document.body.prepend(bar);
        const status = document.createElement('div');
        status.className = 'arcade-session';
        status.innerHTML = '<p id="arcade-status"></p><progress id="arcade-progress" max="100" value="0" aria-label="Game progress"></progress>';
        canvas.after(status);
        const dialog = document.createElement('dialog');
        dialog.className = 'arcade-dialog';
        dialog.setAttribute('aria-labelledby', 'arcade-dialog-title');
        dialog.innerHTML = `<h2 id="arcade-dialog-title">Take a breather.</h2>
      <p id="arcade-dialog-copy"></p><p>${help}</p>
      <div class="arcade-dialog-actions"><button type="button" id="arcade-resume">Resume game</button>
      <button type="button" id="arcade-retry" hidden>Retry this level</button>
      <button type="button" id="arcade-restart">Start a new game</button>
      <a href="../index.html#arcade">Back to arcade</a></div>`;
        document.body.append(dialog);
        const pauseButton = bar.querySelector('#arcade-pause');
        const soundButton = bar.querySelector('#arcade-sound');
        const resumeButton = dialog.querySelector('#arcade-resume');
        const restartButton = dialog.querySelector('#arcade-restart');
        const retryButton = dialog.querySelector('#arcade-retry');
        const syncSound = ()=>{
            soundButton.textContent = this.muted ? 'Sound off (M)' : 'Sound on (M)';
            soundButton.setAttribute('aria-pressed', String(this.muted));
            soundButton.setAttribute('aria-label', this.muted ? 'Unmute sound' : 'Mute sound');
        };
        const resume = ()=>{
            dialog.close();
            this.paused = false;
            clearInput();
            onResume();
            pauseButton.textContent = 'Pause (P)';
            canvas.focus({
                preventScroll: true
            });
        };
        const pause = (helpOnly = false)=>{
            if (dialog.open || !active() && !helpOnly) return;
            this.paused = true;
            clearInput();
            document.querySelectorAll('#mobileControls .active').forEach((el)=>el.classList.remove('active'));
            pauseButton.textContent = 'Resume (P)';
            dialog.querySelector('#arcade-dialog-title').textContent = helpOnly ? `${title}: how to play` : 'Take a breather.';
            dialog.querySelector('#arcade-dialog-copy').textContent = active() ? 'Your game is paused. Your score is safe.' : 'Free play. No quarters required.';
            resumeButton.textContent = active() ? 'Resume game' : 'Back to game';
            restartButton.hidden = !active();
            retryButton.hidden = !retryLevel || !active();
            dialog.showModal();
            resumeButton.focus();
        };
        pauseButton.onclick = ()=>this.paused ? resume() : pause();
        bar.querySelector('#arcade-help').onclick = ()=>pause(true);
        resumeButton.onclick = resume;
        dialog.addEventListener('cancel', (e)=>{
            e.preventDefault();
            resume();
        });
        retryButton.onclick = ()=>{
            resume();
            retryLevel?.();
        };
        restartButton.onclick = ()=>{
            resume();
            restart();
            canvas.focus({
                preventScroll: true
            });
        };
        soundButton.onclick = ()=>{
            this.muted = !this.muted;
            (0, $cuPh8.save)('arcade-muted', this.muted);
            syncSound();
            canvas.focus({
                preventScroll: true
            });
        };
        const fullscreen = bar.querySelector('#arcade-fullscreen');
        fullscreen.hidden = !document.fullscreenEnabled;
        fullscreen.onclick = async ()=>{
            try {
                if (document.fullscreenElement) await document.exitFullscreen();
                else await document.documentElement.requestFullscreen();
            } catch  {
                fullscreen.textContent = 'Full screen unavailable';
            }
        };
        document.addEventListener('fullscreenchange', ()=>{
            fullscreen.textContent = document.fullscreenElement ? 'Exit full screen' : 'Full screen';
        });
        // Capture shortcuts before each game's own handlers. Native controls retain Space/Enter.
        document.addEventListener('keydown', (e)=>{
            const control = e.target.closest?.('button, a, input, select, textarea, summary');
            const typing = e.target.closest?.('input, select, textarea');
            if (!typing && !e.ctrlKey && !e.metaKey && !e.altKey) {
                if (e.code === 'KeyP' || e.code === 'Escape') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!e.repeat) this.paused ? resume() : pause();
                    return;
                }
                if (e.code === 'KeyM') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!e.repeat) soundButton.click();
                    return;
                }
            }
            if (this.paused || control) e.stopImmediatePropagation();
        }, true);
        window.addEventListener('blur', ()=>{
            clearInput();
            pause();
        });
        document.addEventListener('visibilitychange', ()=>{
            if (document.hidden) {
                clearInput();
                pause();
            }
        });
        // Move keyboard focus from a start/continue button onto the running game.
        document.getElementById('gameContainer').addEventListener('click', (e)=>{
            if (e.target.closest('button') && active()) canvas.focus({
                preventScroll: true
            });
        });
        syncSound();
        this.status = (text, progress = 0)=>{
            const label = status.querySelector('p');
            if (label.textContent !== text) label.textContent = text;
            status.querySelector('progress').value = Math.max(0, Math.min(100, progress));
            pauseButton.disabled = !active();
        };
    },
    status () {}
};
function $1373e8fb862fbfa8$export$7e9d9e3ec42ce160(button, press, release = ()=>{}) {
    let pointer = null;
    button.addEventListener('pointerdown', (e)=>{
        if ($1373e8fb862fbfa8$export$11e8552c3b8a3d33.paused || pointer !== null || e.pointerType === 'mouse' && e.button !== 0) return;
        e.preventDefault();
        pointer = e.pointerId;
        button.setPointerCapture(pointer);
        button.classList.add('active');
        press();
    });
    const end = (e)=>{
        if (pointer !== e.pointerId) return;
        pointer = null;
        release();
        button.classList.remove('active');
    };
    button.addEventListener('pointerup', end);
    button.addEventListener('pointercancel', end);
    button.addEventListener('lostpointercapture', end);
}

});
parcelRegister("cuPh8", function(module, exports) {

$parcel$export(module.exports, "readSaved", () => $91900f9c9606830c$export$e63c091f2ff08cc);
$parcel$export(module.exports, "save", () => $91900f9c9606830c$export$a1544dad697b423d);
$parcel$export(module.exports, "savedScore", () => $91900f9c9606830c$export$a1a7e8a3422aeb2c);
const $91900f9c9606830c$var$sessionValues = new Map();
function $91900f9c9606830c$export$e63c091f2ff08cc(key, fallback = '') {
    try {
        return localStorage.getItem(key) ?? $91900f9c9606830c$var$sessionValues.get(key) ?? fallback;
    } catch  {
        return $91900f9c9606830c$var$sessionValues.get(key) ?? fallback;
    }
}
function $91900f9c9606830c$export$a1544dad697b423d(key, value) {
    $91900f9c9606830c$var$sessionValues.set(key, String(value));
    try {
        localStorage.setItem(key, String(value));
        return true;
    } catch  {
        return false;
    }
}
function $91900f9c9606830c$export$a1a7e8a3422aeb2c(key) {
    const score = Number($91900f9c9606830c$export$e63c091f2ff08cc(key, '0'));
    return Number.isFinite(score) && score > 0 ? Math.floor(score) : 0;
}

});



var $1FxTl = parcelRequire("1FxTl");
"use strict";
/* =====================================================================
       GALAGA — authentic 1981 Namco-style rebuild
       Pure vanilla JS + Canvas 2D. Portrait arcade play area.
       Internal backing resolution: 224 x 288 logical pixels, drawn at 2x
       into a 448 x 576 canvas so everything stays crisp & integer-aligned.
       ===================================================================== */ // ---- Constants -----------------------------------------------------
const $961a67820cb7ecad$var$VW = 224; // logical (virtual) game width
const $961a67820cb7ecad$var$VH = 288; // logical game height
const $961a67820cb7ecad$var$SCALE = 2; // backing-store multiplier (canvas is 448x576)
const $961a67820cb7ecad$var$PLAYER_Y = $961a67820cb7ecad$var$VH - 26; // fixed player vertical position
const $961a67820cb7ecad$var$PLAYER_SPEED = 1.3; // logical px / frame
const $961a67820cb7ecad$var$PLAYER_BULLET_SPEED = 4.2;
const $961a67820cb7ecad$var$ENEMY_BULLET_SPEED = 1.4;
const $961a67820cb7ecad$var$SHOT_COOLDOWN = 220; // ms between shots
const $961a67820cb7ecad$var$RESPAWN_INVULN = 2200; // ms of blink invulnerability after death
const $961a67820cb7ecad$var$reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
// ---- Canvas --------------------------------------------------------
const $961a67820cb7ecad$var$canvas = document.getElementById('gameCanvas');
const $961a67820cb7ecad$var$ctx = $961a67820cb7ecad$var$canvas.getContext('2d');
$961a67820cb7ecad$var$ctx.imageSmoothingEnabled = false;
// ---- Audio (chiptune via Web Audio, all guarded) -------------------
let $961a67820cb7ecad$var$audioCtx = null;
try {
    $961a67820cb7ecad$var$audioCtx = new (window.AudioContext || window.webkitAudioContext)();
} catch (e) {
    $961a67820cb7ecad$var$audioCtx = null;
}
function $961a67820cb7ecad$var$resumeAudio() {
    if ($961a67820cb7ecad$var$audioCtx && $961a67820cb7ecad$var$audioCtx.state === 'suspended') $961a67820cb7ecad$var$audioCtx.resume().catch(function() {});
}
// Generic short tone.
function $961a67820cb7ecad$var$tone(freq, dur, type, vol, freqEnd) {
    if (!$961a67820cb7ecad$var$audioCtx || !(0, $1FxTl.arcade).soundEnabled) return;
    try {
        const t0 = $961a67820cb7ecad$var$audioCtx.currentTime;
        const osc = $961a67820cb7ecad$var$audioCtx.createOscillator();
        const g = $961a67820cb7ecad$var$audioCtx.createGain();
        osc.type = type || 'square';
        osc.frequency.setValueAtTime(freq, t0);
        if (typeof freqEnd === 'number') osc.frequency.exponentialRampToValueAtTime(Math.max(1, freqEnd), t0 + dur);
        g.gain.setValueAtTime(vol || 0.18, t0);
        g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
        osc.connect(g);
        g.connect($961a67820cb7ecad$var$audioCtx.destination);
        osc.start(t0);
        osc.stop(t0 + dur + 0.02);
    } catch (e) {}
}
// White-noise burst (explosions).
function $961a67820cb7ecad$var$noiseBurst(dur, vol) {
    if (!$961a67820cb7ecad$var$audioCtx || !(0, $1FxTl.arcade).soundEnabled) return;
    try {
        const t0 = $961a67820cb7ecad$var$audioCtx.currentTime;
        const len = Math.floor($961a67820cb7ecad$var$audioCtx.sampleRate * dur);
        const buf = $961a67820cb7ecad$var$audioCtx.createBuffer(1, len, $961a67820cb7ecad$var$audioCtx.sampleRate);
        const data = buf.getChannelData(0);
        for(let i = 0; i < len; i++)data[i] = (Math.random() * 2 - 1) * (1 - i / len);
        const src = $961a67820cb7ecad$var$audioCtx.createBufferSource();
        src.buffer = buf;
        const g = $961a67820cb7ecad$var$audioCtx.createGain();
        g.gain.setValueAtTime(vol || 0.25, t0);
        g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
        const filt = $961a67820cb7ecad$var$audioCtx.createBiquadFilter();
        filt.type = 'lowpass';
        filt.frequency.value = 1600;
        src.connect(filt);
        filt.connect(g);
        g.connect($961a67820cb7ecad$var$audioCtx.destination);
        src.start(t0);
        src.stop(t0 + dur);
    } catch (e) {}
}
const $961a67820cb7ecad$var$sfx = {
    shoot: function() {
        $961a67820cb7ecad$var$tone(880, 0.08, 'square', 0.12, 220);
    },
    explode: function() {
        $961a67820cb7ecad$var$noiseBurst(0.3, 0.3);
    },
    hit: function() {
        $961a67820cb7ecad$var$tone(330, 0.07, 'triangle', 0.15, 180);
    },
    dive: function() {
        $961a67820cb7ecad$var$tone(200, 0.25, 'sawtooth', 0.1, 700);
    },
    capture: function() {
        $961a67820cb7ecad$var$tone(700, 0.5, 'sine', 0.18, 120);
        $961a67820cb7ecad$var$tone(350, 0.5, 'sine', 0.12, 80);
    },
    rescue: function() {
        $961a67820cb7ecad$var$tone(523, 0.1, 'square', 0.15);
        setTimeout(function() {
            $961a67820cb7ecad$var$tone(659, 0.1, 'square', 0.15);
        }, 90);
        setTimeout(function() {
            $961a67820cb7ecad$var$tone(784, 0.1, 'square', 0.15);
        }, 180);
        setTimeout(function() {
            $961a67820cb7ecad$var$tone(1046, 0.2, 'square', 0.16);
        }, 270);
    },
    stageStart: function() {
        $961a67820cb7ecad$var$tone(523, 0.12, 'square', 0.14);
        setTimeout(function() {
            $961a67820cb7ecad$var$tone(784, 0.12, 'square', 0.14);
        }, 120);
        setTimeout(function() {
            $961a67820cb7ecad$var$tone(1046, 0.16, 'square', 0.14);
        }, 240);
    },
    coin: function() {
        $961a67820cb7ecad$var$tone(988, 0.06, 'square', 0.13);
        setTimeout(function() {
            $961a67820cb7ecad$var$tone(1318, 0.1, 'square', 0.13);
        }, 60);
    }
};
// ---- Pixel font ----------------------------------------------------
// Hand-rolled 5x5-ish bitmap font (each glyph is 5 rows of 4 cols).
// 1 = lit pixel. Drawn with fillRect so it stays chunky & crisp.
const $961a67820cb7ecad$var$FONT = {
    '0': [
        "1111",
        "1001",
        "1001",
        "1001",
        "1111"
    ],
    '1': [
        "0010",
        "0110",
        "0010",
        "0010",
        "0111"
    ],
    '2': [
        "1111",
        "0001",
        "1111",
        "1000",
        "1111"
    ],
    '3': [
        "1111",
        "0001",
        "0111",
        "0001",
        "1111"
    ],
    '4': [
        "1001",
        "1001",
        "1111",
        "0001",
        "0001"
    ],
    '5': [
        "1111",
        "1000",
        "1111",
        "0001",
        "1111"
    ],
    '6': [
        "1111",
        "1000",
        "1111",
        "1001",
        "1111"
    ],
    '7': [
        "1111",
        "0001",
        "0010",
        "0100",
        "0100"
    ],
    '8': [
        "1111",
        "1001",
        "1111",
        "1001",
        "1111"
    ],
    '9': [
        "1111",
        "1001",
        "1111",
        "0001",
        "1111"
    ],
    'A': [
        "0110",
        "1001",
        "1111",
        "1001",
        "1001"
    ],
    'B': [
        "1110",
        "1001",
        "1110",
        "1001",
        "1110"
    ],
    'C': [
        "0111",
        "1000",
        "1000",
        "1000",
        "0111"
    ],
    'D': [
        "1110",
        "1001",
        "1001",
        "1001",
        "1110"
    ],
    'E': [
        "1111",
        "1000",
        "1110",
        "1000",
        "1111"
    ],
    'F': [
        "1111",
        "1000",
        "1110",
        "1000",
        "1000"
    ],
    'G': [
        "0111",
        "1000",
        "1011",
        "1001",
        "0111"
    ],
    'H': [
        "1001",
        "1001",
        "1111",
        "1001",
        "1001"
    ],
    'I': [
        "111",
        "010",
        "010",
        "010",
        "111"
    ],
    'J': [
        "0011",
        "0001",
        "0001",
        "1001",
        "0110"
    ],
    'K': [
        "1001",
        "1010",
        "1100",
        "1010",
        "1001"
    ],
    'L': [
        "1000",
        "1000",
        "1000",
        "1000",
        "1111"
    ],
    'M': [
        "10001",
        "11011",
        "10101",
        "10001",
        "10001"
    ],
    'N': [
        "1001",
        "1101",
        "1011",
        "1001",
        "1001"
    ],
    'O': [
        "0110",
        "1001",
        "1001",
        "1001",
        "0110"
    ],
    'P': [
        "1110",
        "1001",
        "1110",
        "1000",
        "1000"
    ],
    'Q': [
        "0110",
        "1001",
        "1001",
        "1011",
        "0111"
    ],
    'R': [
        "1110",
        "1001",
        "1110",
        "1010",
        "1001"
    ],
    'S': [
        "0111",
        "1000",
        "0110",
        "0001",
        "1110"
    ],
    'T': [
        "11111",
        "00100",
        "00100",
        "00100",
        "00100"
    ],
    'U': [
        "1001",
        "1001",
        "1001",
        "1001",
        "0110"
    ],
    'V': [
        "1001",
        "1001",
        "1001",
        "0110",
        "0110"
    ],
    'W': [
        "10001",
        "10001",
        "10101",
        "11011",
        "10001"
    ],
    'X': [
        "1001",
        "1001",
        "0110",
        "1001",
        "1001"
    ],
    'Y': [
        "10001",
        "01010",
        "00100",
        "00100",
        "00100"
    ],
    'Z': [
        "1111",
        "0010",
        "0100",
        "1000",
        "1111"
    ],
    '-': [
        "0000",
        "0000",
        "1111",
        "0000",
        "0000"
    ],
    '!': [
        "010",
        "010",
        "010",
        "000",
        "010"
    ],
    '.': [
        "00",
        "00",
        "00",
        "00",
        "11"
    ],
    ':': [
        "00",
        "11",
        "00",
        "11",
        "00"
    ],
    '/': [
        "0001",
        "0010",
        "0100",
        "1000",
        "0000"
    ],
    ' ': [
        "000",
        "000",
        "000",
        "000",
        "000"
    ]
};
// Measure rendered width of a string for a given pixel size.
function $961a67820cb7ecad$var$textWidth(str, px) {
    let w = 0;
    for(let i = 0; i < str.length; i++){
        const g = $961a67820cb7ecad$var$FONT[str[i].toUpperCase()] || $961a67820cb7ecad$var$FONT[' '];
        w += (g[0].length + 1) * px; // +1 col spacing
    }
    return w - px;
}
// Draw arcade text at logical coords (caller already applied SCALE via ctx transform).
function $961a67820cb7ecad$var$drawText(str, x, y, px, color) {
    $961a67820cb7ecad$var$ctx.fillStyle = color || '#fff';
    let cx = x;
    for(let i = 0; i < str.length; i++){
        const g = $961a67820cb7ecad$var$FONT[str[i].toUpperCase()] || $961a67820cb7ecad$var$FONT[' '];
        for(let r = 0; r < g.length; r++){
            const row = g[r];
            for(let c = 0; c < row.length; c++)if (row[c] === '1') $961a67820cb7ecad$var$ctx.fillRect(cx + c * px, y + r * px, px, px);
        }
        cx += (g[0].length + 1) * px;
    }
}
function $961a67820cb7ecad$var$drawTextCentered(str, y, px, color) {
    $961a67820cb7ecad$var$drawText(str, Math.round(($961a67820cb7ecad$var$VW - $961a67820cb7ecad$var$textWidth(str, px)) / 2), y, px, color);
}
// ---- Sprite system -------------------------------------------------
// Each sprite is an array of equal-length strings; chars index a palette
// object ('.' = transparent). drawSprite fills integer-aligned rects.
function $961a67820cb7ecad$var$drawSprite(grid, palette, x, y, scale) {
    scale = scale || 1;
    x = Math.round(x);
    y = Math.round(y);
    for(let r = 0; r < grid.length; r++){
        const row = grid[r];
        for(let c = 0; c < row.length; c++){
            const ch = row[c];
            if (ch === '.') continue;
            const col = palette[ch];
            if (!col) continue;
            $961a67820cb7ecad$var$ctx.fillStyle = col;
            $961a67820cb7ecad$var$ctx.fillRect(x + c * scale, y + r * scale, scale, scale);
        }
    }
}
// -- Palettes --
const $961a67820cb7ecad$var$PAL = {
    W: '#ffffff',
    R: '#ff2020',
    B: '#3858ff',
    C: '#28e0f0',
    Y: '#ffe000',
    G: '#28d028',
    P: '#c040ff',
    K: '#000000',
    O: '#ff8000',
    g: '#108010'
};
// -- Player fighter (13x16): white body, red wing tips, cyan core --
const $961a67820cb7ecad$var$SPR_PLAYER = [
    ".......W.......",
    ".......W.......",
    "......WWW......",
    "......WCW......",
    "......WCW......",
    ".....WWCWW.....",
    ".....WWCWW.....",
    "....WWWCWWW....",
    "...RWWWCWWWR...",
    "..RRWWWCWWWRR..",
    ".RRRWWWCWWWRRR.",
    ".RRRWWWWWWWRRR.",
    ".R.WWWWWWWWW.R.",
    "...WW.WWW.WW...",
    "....W..W..W....",
    ".......W......."
];
// -- Bee / Zako (blue & yellow), 2 anim frames (13x12) --
const $961a67820cb7ecad$var$SPR_BEE_A = [
    ".....Y...Y.....",
    "......Y.Y......",
    "..B...YYY...B..",
    "..BB.YBYBY.BB..",
    ".BBBBYYYYYBBBB.",
    "BBYBBBYYYBBBYBB",
    "BBYBBBBYBBBBYBB",
    ".BB.BYYYYYB.BB.",
    "....BBYYYBB....",
    "...BB.....BB...",
    "..B.........B..",
    ".B...........B."
];
const $961a67820cb7ecad$var$SPR_BEE_B = [
    ".B...Y...Y...B.",
    "..B...Y.Y...B..",
    "..BB..YYY..BB..",
    "...B.YBYBY.B...",
    ".BBBBYYYYYBBBB.",
    "BBYBBBYYYBBBYBB",
    "BBYBBBBYBBBBYBB",
    "..B.BYYYYYB.B..",
    "....BBYYYBB....",
    ".....B...B.....",
    "....B.....B....",
    "...B.......B..."
];
// -- Butterfly / Goei (red & white with blue), 2 frames (13x13) --
const $961a67820cb7ecad$var$SPR_BUT_A = [
    "......R......",
    ".....RRR.....",
    "R...RWRWR...R",
    "RR.RRWRWRR.RR",
    "RRRBRWRWRBRRR",
    ".RRBBRRRBBRR.",
    "..RBWWRWWBR..",
    "...RWWRWWR...",
    "..RRRWRWRRR..",
    ".RR..RRR..RR.",
    "RR...R.R...RR",
    "R...RR.RR...R",
    "...RR...RR..."
];
const $961a67820cb7ecad$var$SPR_BUT_B = [
    "R.....R.....R",
    "RR...RRR...RR",
    "RRR.RWRWR.RRR",
    ".RRRRWRWRRRR.",
    "..RBRWRWRBR..",
    "..RBBRRRBBR..",
    "...BWWRWWB...",
    "...RWWRWWR...",
    "....RWRWR....",
    "...RRRRRRR...",
    "..RR..R..RR..",
    ".R...RRR...R.",
    "R...RR.RR...R"
];
// -- Boss Galaga (green dome + blue body), 2 frames (15x14) --
const $961a67820cb7ecad$var$SPR_BOSS_A = [
    ".....GGGGG.....",
    "...GGGGGGGGG...",
    "..GGCGGGGGCGG..",
    "..GGGGGGGGGGG..",
    ".BBGGGGGGGGGBB.",
    "BBBBGGGGGGGBBBB",
    "BBYBBGGGGGBBYBB",
    "BBYBBBBBBBBBYBB",
    ".BBBBYYYYYBBBB.",
    "..BB.YYYYY.BB..",
    "...B.YY.YY.B...",
    "..BB.Y...Y.BB..",
    ".BB...........BB",
    "B...............B"
];
const $961a67820cb7ecad$var$SPR_BOSS_B = [
    ".....GGGGG.....",
    "...GGGGGGGGG...",
    "..GGCGGGGGCGG..",
    "..GGGGGGGGGGG..",
    "BBBGGGGGGGGGBBB",
    "BBBBGGGGGGGBBBB",
    "BBYBBGGGGGBBYBB",
    ".BYBBBBBBBBBYB.",
    "..BBBYYYYYBBB..",
    "...B.YYYYY.B...",
    "..BB.YY.YY.BB..",
    ".BB..Y...Y..BB.",
    "B....Y...Y....B",
    "......B.B......"
];
// Boss damaged (hit once) — blue/purple flashing version (15x14)
const $961a67820cb7ecad$var$SPR_BOSS_HURT = [
    ".....PPPPP.....",
    "...PPPPPPPPP...",
    "..PPCPPPPPCPP..",
    "..PPPPPPPPPPP..",
    ".BBPPPPPPPPPBB.",
    "BBBBPPPPPPPBBBB",
    "BBWBBPPPPPBBWBB",
    "BBWBBBBBBBBBWBB",
    ".BBBBWWWWWBBBB.",
    "..BB.WWWWW.BB..",
    "...B.WW.WW.B...",
    "..BB.W...W.BB..",
    ".BB...........BB",
    "B...............B"
];
// -- Captured fighter (player ship tinted, shown above a boss) --
// Reuse player sprite; tint handled by drawing a slightly different pal.
const $961a67820cb7ecad$var$PAL_CAPTURED = {
    W: '#80c0ff',
    R: '#ff2020',
    C: '#28e0f0',
    K: '#000000'
};
// -- Explosion frames (expanding) 16x16, classic Galaga burst --
const $961a67820cb7ecad$var$EXP = [
    [
        "................",
        "................",
        "................",
        "......O.O.......",
        ".......OO.......",
        "......OOOO......",
        ".......OO.......",
        "......O.O.......",
        "................",
        "................",
        "................",
        "................",
        "................",
        "................",
        "................",
        "................"
    ],
    [
        "................",
        "................",
        "....O.....O.....",
        ".....O.Y.O......",
        "......YOY.......",
        "...O.YOOOY.O....",
        "......YOY.......",
        ".....O.Y.O......",
        "....O.....O.....",
        "................",
        "................",
        "................",
        "................",
        "................",
        "................",
        "................"
    ],
    [
        "................",
        "...O..O.O..O....",
        "..O..YO.OY..O...",
        "....YO.R.OY.....",
        "...O.RO.OR.O....",
        "..O.O.OOO.O.O...",
        "...O.RO.OR.O....",
        "....YO.R.OY.....",
        "..O..YO.OY..O...",
        "...O..O.O..O....",
        "................",
        "................",
        "................",
        "................",
        "................",
        "................"
    ],
    [
        ".O...O...O...O..",
        "..O.O.Y.Y.O.O...",
        "O..O.R...R.O..O.",
        "..O.R..Y..R.O...",
        ".Y.R..OOO..R.Y..",
        "O...O.OYO.O...O.",
        ".Y.R..OOO..R.Y..",
        "..O.R..Y..R.O...",
        "O..O.R...R.O..O.",
        "..O.O.Y.Y.O.O...",
        ".O...O...O...O..",
        "................",
        "................",
        "................",
        "................",
        "................"
    ],
    [
        "O....O...O....O.",
        "..O..............",
        "....O..Y.Y..O...",
        ".O....R...R...O.",
        "...R...O.O...R..",
        ".Y...O.....O..Y.",
        "..O...........O.",
        "O.....O...O....O",
        "..O...........O.",
        ".Y...O.....O..Y.",
        "...R...O.O...R..",
        ".O....R...R...O.",
        "....O..Y.Y..O...",
        "..O.............",
        "O....O...O....O.",
        "................"
    ]
];
const $961a67820cb7ecad$var$PAL_EXP = {
    O: '#ff8000',
    Y: '#ffe000',
    R: '#ff2020'
};
// ---- Enemy formation layout ---------------------------------------
// Classic Galaga grid: 10 columns wide, rows of boss/butterfly/bee.
const $961a67820cb7ecad$var$GRID_COLS = 10;
const $961a67820cb7ecad$var$CELL_W = 16; // horizontal spacing between formation slots
const $961a67820cb7ecad$var$CELL_H = 17; // vertical spacing
const $961a67820cb7ecad$var$FORM_TOP = 36; // y of the top formation row
const $961a67820cb7ecad$var$FORM_LEFT = ($961a67820cb7ecad$var$VW - ($961a67820cb7ecad$var$GRID_COLS - 1) * $961a67820cb7ecad$var$CELL_W) / 2; // centered
// Enemy kind metadata.
const $961a67820cb7ecad$var$KIND = {
    bee: {
        w: 13,
        h: 12,
        frames: [
            $961a67820cb7ecad$var$SPR_BEE_A,
            $961a67820cb7ecad$var$SPR_BEE_B
        ],
        pal: $961a67820cb7ecad$var$PAL,
        scoreForm: 50,
        scoreDive: 100,
        hp: 1,
        fire: 0.0016
    },
    butterfly: {
        w: 13,
        h: 13,
        frames: [
            $961a67820cb7ecad$var$SPR_BUT_A,
            $961a67820cb7ecad$var$SPR_BUT_B
        ],
        pal: $961a67820cb7ecad$var$PAL,
        scoreForm: 80,
        scoreDive: 160,
        hp: 1,
        fire: 0.0020
    },
    boss: {
        w: 15,
        h: 14,
        frames: [
            $961a67820cb7ecad$var$SPR_BOSS_A,
            $961a67820cb7ecad$var$SPR_BOSS_B
        ],
        pal: $961a67820cb7ecad$var$PAL,
        scoreForm: 150,
        scoreDive: 400,
        hp: 2,
        fire: 0.0024
    }
};
// ---- Game state ----------------------------------------------------
let $961a67820cb7ecad$var$gameState = 'start'; // start, fly-in, playing, stage-clear, dying, gameover
let $961a67820cb7ecad$var$score = 0;
let $961a67820cb7ecad$var$shotsFired = 0;
let $961a67820cb7ecad$var$shotsHit = 0;
let $961a67820cb7ecad$var$nextExtraLife = 20000;
let $961a67820cb7ecad$var$simulationTime = 0;
let $961a67820cb7ecad$var$highScore = 0;
try {
    $961a67820cb7ecad$var$highScore = parseInt(localStorage.getItem('galagaHighScore') || '0', 10) || 0;
} catch (e) {}
let $961a67820cb7ecad$var$lives = 3;
let $961a67820cb7ecad$var$stage = 1;
let $961a67820cb7ecad$var$isChallenge = false;
const $961a67820cb7ecad$var$keys = {};
let $961a67820cb7ecad$var$lastShotTime = 0;
let $961a67820cb7ecad$var$shakeTime = 0; // screen-shake timer (ms)
let $961a67820cb7ecad$var$stageBannerTimer = 0; // ms remaining to show STAGE banner
let $961a67820cb7ecad$var$perfectTimer = 0; // ms remaining to show PERFECT
let $961a67820cb7ecad$var$blinkPhase = 0; // global blink counter for flashing things
// Player object (supports dual fighter).
const $961a67820cb7ecad$var$player = {
    x: $961a67820cb7ecad$var$VW / 2,
    alive: true,
    dual: false,
    invulnUntil: 0,
    respawning: false,
    captured: false,
    captureAnim: 0
};
let $961a67820cb7ecad$var$bullets = []; // player bullets
let $961a67820cb7ecad$var$enemyBullets = [];
let $961a67820cb7ecad$var$enemies = []; // all live enemies (formation + diving + flying in)
let $961a67820cb7ecad$var$particles = []; // explosion sprites + sparks
let $961a67820cb7ecad$var$popups = []; // floating score text
let $961a67820cb7ecad$var$stars = []; // starfield
let $961a67820cb7ecad$var$flyInQueue = []; // groups still to spawn during fly-in
let $961a67820cb7ecad$var$flyInTimer = 0;
let $961a67820cb7ecad$var$diveTimer = 0; // ms accumulator for scheduling dives
let $961a67820cb7ecad$var$captureCooldown = 0; // ms before another capture attempt may start
let $961a67820cb7ecad$var$captureActive = false; // a boss is currently running a capture dive
// The boss that currently holds a captured fighter (for rescue logic).
let $961a67820cb7ecad$var$capturedHolder = null;
// Challenging-stage hit tracking: the PERFECT bonus is only awarded if the
// player destroys every enemy that flies through (8 waves x 5 = 40).
const $961a67820cb7ecad$var$CHALLENGE_TOTAL = 40;
let $961a67820cb7ecad$var$challengeKills = 0;
// ---- Starfield -----------------------------------------------------
function $961a67820cb7ecad$var$initStars() {
    $961a67820cb7ecad$var$stars = [];
    const colors = [
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#88aaff',
        '#ff8888',
        '#ffff88'
    ];
    for(let i = 0; i < 80; i++)$961a67820cb7ecad$var$stars.push({
        x: Math.floor(Math.random() * $961a67820cb7ecad$var$VW),
        y: Math.floor(Math.random() * $961a67820cb7ecad$var$VH),
        speed: 0.2 + Math.random() * 0.6,
        color: colors[Math.floor(Math.random() * colors.length)],
        twinkle: Math.random() * Math.PI * 2,
        twSpeed: 0.05 + Math.random() * 0.1
    });
}
function $961a67820cb7ecad$var$updateStars(dt) {
    for(let i = 0; i < $961a67820cb7ecad$var$stars.length; i++){
        const s = $961a67820cb7ecad$var$stars[i];
        s.y += s.speed * dt;
        if (s.y >= $961a67820cb7ecad$var$VH) {
            s.y = 0;
            s.x = Math.floor(Math.random() * $961a67820cb7ecad$var$VW);
        }
        s.twinkle += s.twSpeed * dt;
    }
}
function $961a67820cb7ecad$var$drawStars() {
    for(let i = 0; i < $961a67820cb7ecad$var$stars.length; i++){
        const s = $961a67820cb7ecad$var$stars[i];
        // Twinkle: skip drawing when in the "off" part of the sine wave.
        if (Math.sin(s.twinkle) > -0.3) {
            $961a67820cb7ecad$var$ctx.fillStyle = s.color;
            $961a67820cb7ecad$var$ctx.fillRect(Math.floor(s.x), Math.floor(s.y), 1, 1);
        }
    }
}
// ---- Enemy factory -------------------------------------------------
function $961a67820cb7ecad$var$makeEnemy(kind, col, row, slotX, slotY) {
    const meta = $961a67820cb7ecad$var$KIND[kind];
    return {
        kind: kind,
        col: col,
        row: row,
        homeX: slotX,
        homeY: slotY,
        x: slotX,
        y: slotY,
        w: meta.w,
        h: meta.h,
        hp: meta.hp,
        state: 'flyin',
        // fly-in path
        path: null,
        pathT: 0,
        pathDur: 0,
        // dive
        diveT: 0,
        divePath: null,
        diveDur: 0,
        angle: 0,
        // boss capture
        isCapturing: false,
        beam: 0,
        holdsCaptured: false,
        // escort link (for boss V dives)
        escortLeader: null,
        escortOffset: 0,
        // animation
        flap: Math.random() * Math.PI * 2,
        hurtFlash: 0,
        fireChance: meta.fire
    };
}
// Assign a kind to a formation row (Galaga layout).
function $961a67820cb7ecad$var$kindForRow(row) {
    if (row === 0) return 'boss'; // top row: flagships (but only middle cols get bosses)
    if (row <= 2) return 'butterfly'; // next 2 rows
    return 'bee'; // bottom rows
}
// Build the formation roster + a staggered fly-in queue.
function $961a67820cb7ecad$var$buildStage() {
    $961a67820cb7ecad$var$enemies = [];
    $961a67820cb7ecad$var$flyInQueue = [];
    $961a67820cb7ecad$var$capturedHolder = null;
    $961a67820cb7ecad$var$captureActive = false;
    $961a67820cb7ecad$var$captureCooldown = 4000 + Math.random() * 3000;
    if ($961a67820cb7ecad$var$isChallenge) {
        $961a67820cb7ecad$var$buildChallengeStage();
        return;
    }
    // Standard formation: 5 rows. Row 0 has 4 bosses (cols 3..6).
    const rows = 5;
    const roster = [];
    for(let row = 0; row < rows; row++)for(let col = 0; col < $961a67820cb7ecad$var$GRID_COLS; col++){
        let kind = $961a67820cb7ecad$var$kindForRow(row);
        if (kind === 'boss') {
            // Only the central 4 columns are bosses; sides skip row 0.
            if (col < 3 || col > 6) continue;
        }
        const slotX = $961a67820cb7ecad$var$FORM_LEFT + col * $961a67820cb7ecad$var$CELL_W;
        const slotY = $961a67820cb7ecad$var$FORM_TOP + row * $961a67820cb7ecad$var$CELL_H;
        roster.push($961a67820cb7ecad$var$makeEnemy(kind, col, row, slotX, slotY));
    }
    // Group the roster into fly-in waves of ~6 that share an entry path.
    // Alternate entry sides for visual variety.
    let group = [];
    let groupIndex = 0;
    for(let i = 0; i < roster.length; i++){
        group.push(roster[i]);
        if (group.length >= 6 || i === roster.length - 1) {
            $961a67820cb7ecad$var$flyInQueue.push({
                members: group,
                side: groupIndex % 2,
                delay: groupIndex * 650
            });
            group = [];
            groupIndex++;
        }
    }
    $961a67820cb7ecad$var$flyInTimer = 0;
}
// Challenging stage: enemies fly through in patterns, do not shoot.
function $961a67820cb7ecad$var$buildChallengeStage() {
    // 8 waves of 5 enemies sweeping across; they never reach formation.
    $961a67820cb7ecad$var$challengeKills = 0;
    const kinds = [
        'bee',
        'butterfly',
        'boss'
    ];
    let groupIndex = 0;
    for(let g = 0; g < 8; g++){
        const members = [];
        const kind = kinds[g % kinds.length];
        for(let k = 0; k < 5; k++){
            const e = $961a67820cb7ecad$var$makeEnemy(kind, k, 0, $961a67820cb7ecad$var$VW / 2, -20);
            e.challenge = true; // never docks, never shoots
            e.hp = $961a67820cb7ecad$var$KIND[kind].hp;
            members.push(e);
        }
        $961a67820cb7ecad$var$flyInQueue.push({
            members: members,
            side: g % 2,
            delay: g * 900,
            challenge: true
        });
        groupIndex++;
    }
    $961a67820cb7ecad$var$flyInTimer = 0;
}
// ---- Bezier helpers for curved paths -------------------------------
function $961a67820cb7ecad$var$bezier(p0, p1, p2, p3, t) {
    const u = 1 - t;
    const tt = t * t, uu = u * u;
    const uuu = uu * u, ttt = tt * t;
    return uuu * p0 + 3 * uu * t * p1 + 3 * u * tt * p2 + ttt * p3;
}
// Create a looping fly-in path from off-screen to a formation slot.
function $961a67820cb7ecad$var$makeFlyInPath(side, slotX, slotY, idx) {
    // Entry from a side, loop, then approach the slot.
    const startX = side === 0 ? -20 : $961a67820cb7ecad$var$VW + 20;
    const startY = 40 + idx * 6;
    // A swirl control set producing a loop.
    const cx = side === 0 ? $961a67820cb7ecad$var$VW * 0.30 : $961a67820cb7ecad$var$VW * 0.70;
    const p1x = side === 0 ? $961a67820cb7ecad$var$VW * 0.55 : $961a67820cb7ecad$var$VW * 0.45;
    const p1y = 30;
    const p2x = cx;
    const p2y = 120;
    return {
        p0x: startX,
        p0y: startY,
        p1x: p1x,
        p1y: p1y,
        p2x: p2x,
        p2y: p2y,
        p3x: slotX,
        p3y: slotY
    };
}
// Challenge-stage sweep path: in one side, big arc, out the other/bottom.
function $961a67820cb7ecad$var$makeChallengePath(side, idx) {
    const startX = side === 0 ? -20 : $961a67820cb7ecad$var$VW + 20;
    const startY = 20 + idx * 10;
    const endX = side === 0 ? $961a67820cb7ecad$var$VW + 20 : -20;
    const endY = 200 - idx * 8;
    return {
        p0x: startX,
        p0y: startY,
        p1x: $961a67820cb7ecad$var$VW * 0.25,
        p1y: 150,
        p2x: $961a67820cb7ecad$var$VW * 0.75,
        p2y: 60 + idx * 12,
        p3x: endX,
        p3y: endY
    };
}
// ---- Stage / wave control -----------------------------------------
function $961a67820cb7ecad$var$beginStage() {
    $961a67820cb7ecad$var$isChallenge = $961a67820cb7ecad$var$stage % 3 === 0;
    $961a67820cb7ecad$var$buildStage();
    $961a67820cb7ecad$var$gameState = 'flyin';
    $961a67820cb7ecad$var$stageBannerTimer = $961a67820cb7ecad$var$isChallenge ? 1800 : 1400;
    $961a67820cb7ecad$var$perfectTimer = 0;
    $961a67820cb7ecad$var$diveTimer = 0;
    $961a67820cb7ecad$var$sfx.stageStart();
    $961a67820cb7ecad$var$updateUI();
}
function $961a67820cb7ecad$var$startFlyInGroup(grp) {
    for(let i = 0; i < grp.members.length; i++){
        const e = grp.members[i];
        e.state = 'flyin';
        if (grp.challenge) e.path = $961a67820cb7ecad$var$makeChallengePath(grp.side, i);
        else e.path = $961a67820cb7ecad$var$makeFlyInPath(grp.side, e.homeX, e.homeY, i);
        e.pathT = -i * 0.12; // small stagger inside the group
        e.pathDur = grp.challenge ? 2.0 : 1.6;
        e.x = e.path.p0x;
        e.y = e.path.p0y;
        $961a67820cb7ecad$var$enemies.push(e);
    }
    $961a67820cb7ecad$var$sfx.dive();
}
// ---- Formation breathing -------------------------------------------
let $961a67820cb7ecad$var$formationPhase = 0;
function $961a67820cb7ecad$var$formationOffsetX() {
    // Sway side to side.
    return Math.sin($961a67820cb7ecad$var$formationPhase) * 8;
}
function $961a67820cb7ecad$var$formationScale() {
    // Slight expand/contract breathing.
    return 1 + Math.sin($961a67820cb7ecad$var$formationPhase * 0.7) * 0.04;
}
function $961a67820cb7ecad$var$slotPosition(e) {
    const sx = $961a67820cb7ecad$var$formationScale();
    const cxCenter = $961a67820cb7ecad$var$FORM_LEFT + ($961a67820cb7ecad$var$GRID_COLS - 1) * $961a67820cb7ecad$var$CELL_W / 2;
    const x = cxCenter + (e.homeX - cxCenter) * sx + $961a67820cb7ecad$var$formationOffsetX();
    const y = e.homeY;
    return {
        x: x,
        y: y
    };
}
// ---- Diving logic --------------------------------------------------
function $961a67820cb7ecad$var$pickDivers() {
    // Choose formation enemies to peel off.
    const candidates = $961a67820cb7ecad$var$enemies.filter(function(e) {
        return e.state === 'formation' && !e.isCapturing;
    });
    if (candidates.length === 0) return;
    // Maybe trigger a boss capture dive instead of a normal dive.
    if (!$961a67820cb7ecad$var$captureActive && $961a67820cb7ecad$var$captureCooldown <= 0 && !$961a67820cb7ecad$var$player.dual && !$961a67820cb7ecad$var$player.captured && $961a67820cb7ecad$var$capturedHolder === null) {
        const bosses = candidates.filter(function(e) {
            return e.kind === 'boss';
        });
        if (bosses.length > 0 && Math.random() < 0.5) {
            $961a67820cb7ecad$var$startCaptureDive(bosses[Math.floor(Math.random() * bosses.length)]);
            return;
        }
    }
    // Normal dive: 1-3 enemies. Bosses lead escorts in a V.
    const maxDivers = Math.min(1 + Math.floor($961a67820cb7ecad$var$stage / 2), 3);
    const count = 1 + Math.floor(Math.random() * maxDivers);
    for(let n = 0; n < count; n++){
        const e = candidates[Math.floor(Math.random() * candidates.length)];
        if (!e || e.state !== 'formation') continue;
        if (e.kind === 'boss') {
            $961a67820cb7ecad$var$startDive(e);
            // Give the boss up to 2 escorts from nearby butterflies/bees.
            const escorts = candidates.filter(function(c) {
                return c.state === 'formation' && c !== e && c.kind !== 'boss';
            }).slice(0, 2);
            for(let j = 0; j < escorts.length; j++)$961a67820cb7ecad$var$startDive(escorts[j], e, j === 0 ? -10 : 10);
        } else $961a67820cb7ecad$var$startDive(e);
    }
}
function $961a67820cb7ecad$var$startDive(e, leader, offset) {
    e.state = 'dive';
    e.diveT = 0;
    e.diveDur = 2.4;
    e.escortLeader = leader || null;
    e.escortOffset = offset || 0;
    const pos = $961a67820cb7ecad$var$slotPosition(e);
    // Swooping dive path toward the player's side then off bottom.
    const targetX = $961a67820cb7ecad$var$player.x + (Math.random() * 60 - 30);
    const dir = pos.x < $961a67820cb7ecad$var$VW / 2 ? 1 : -1;
    e.divePath = {
        p0x: pos.x,
        p0y: pos.y,
        p1x: pos.x + dir * 30,
        p1y: pos.y + 40,
        p2x: targetX - dir * 40,
        p2y: $961a67820cb7ecad$var$VH * 0.6,
        p3x: targetX,
        p3y: $961a67820cb7ecad$var$VH + 20
    };
    $961a67820cb7ecad$var$sfx.dive();
}
function $961a67820cb7ecad$var$startCaptureDive(boss) {
    $961a67820cb7ecad$var$captureActive = true;
    boss.isCapturing = true;
    boss.state = 'capture';
    boss.captureT = 0;
    boss.beam = 0;
    boss.capturePhase = 'descend'; // descend -> beam -> retreat
    const pos = $961a67820cb7ecad$var$slotPosition(boss);
    boss.captureFromX = pos.x;
    boss.captureFromY = pos.y;
    // Descends to about 45% down, roughly above the player.
    boss.captureTargetX = Math.max(30, Math.min($961a67820cb7ecad$var$VW - 30, $961a67820cb7ecad$var$player.x));
    boss.captureTargetY = $961a67820cb7ecad$var$VH * 0.42;
    $961a67820cb7ecad$var$sfx.dive();
}
// ---- Update: fly-in -------------------------------------------------
function $961a67820cb7ecad$var$updateFlyIn(dt, dtMs) {
    $961a67820cb7ecad$var$flyInTimer += dtMs;
    // Release queued groups on schedule.
    for(let i = $961a67820cb7ecad$var$flyInQueue.length - 1; i >= 0; i--)if ($961a67820cb7ecad$var$flyInTimer >= $961a67820cb7ecad$var$flyInQueue[i].delay) {
        $961a67820cb7ecad$var$startFlyInGroup($961a67820cb7ecad$var$flyInQueue[i]);
        $961a67820cb7ecad$var$flyInQueue.splice(i, 1);
    }
    // Advance fly-in motion (handled in updateEnemies). When all enemies
    // have docked (or, for challenge, left) and the queue is empty, the
    // stage proper begins.
    const allDone = $961a67820cb7ecad$var$flyInQueue.length === 0 && $961a67820cb7ecad$var$enemies.every(function(e) {
        return e.state === 'formation' || e.challenge && false;
    });
    if ($961a67820cb7ecad$var$isChallenge) // Challenge stages stay in the 'flyin' state for their whole
    // duration. The loop's 'flyin' branch already runs the player,
    // bullets and collisions, and staying here keeps updateFlyIn
    // draining flyInQueue each frame so all 8 waves are released on
    // schedule. The stage ends only once every wave has been released
    // and no enemies remain (shot down or swept off-screen).
    {
        if ($961a67820cb7ecad$var$flyInQueue.length === 0 && $961a67820cb7ecad$var$enemies.length === 0) $961a67820cb7ecad$var$finishChallenge();
    } else if (allDone && $961a67820cb7ecad$var$enemies.length > 0) {
        $961a67820cb7ecad$var$gameState = 'playing';
        $961a67820cb7ecad$var$diveTimer = 0;
    }
}
function $961a67820cb7ecad$var$finishChallenge() {
    // Award the PERFECT bonus only if every challenge enemy was destroyed
    // (the authentic rule); otherwise show how many were hit.
    if ($961a67820cb7ecad$var$challengeKills >= $961a67820cb7ecad$var$CHALLENGE_TOTAL) {
        $961a67820cb7ecad$var$perfectTimer = 1800;
        $961a67820cb7ecad$var$score += 10000;
        $961a67820cb7ecad$var$sfx.rescue();
        $961a67820cb7ecad$var$spawnPopup($961a67820cb7ecad$var$VW / 2 - 20, $961a67820cb7ecad$var$VH / 2, 'PERFECT', '#ffe000');
    } else $961a67820cb7ecad$var$spawnPopup($961a67820cb7ecad$var$VW / 2 - 32, $961a67820cb7ecad$var$VH / 2, $961a67820cb7ecad$var$challengeKills + ' / ' + $961a67820cb7ecad$var$CHALLENGE_TOTAL + ' HITS', '#ffffff');
    $961a67820cb7ecad$var$updateUI();
    $961a67820cb7ecad$var$gameState = 'stage-clear';
    $961a67820cb7ecad$var$stageClearTimer = 1800;
}
// ---- Update: enemies ------------------------------------------------
let $961a67820cb7ecad$var$stageClearTimer = 0;
function $961a67820cb7ecad$var$updateEnemies(dt, dtMs) {
    $961a67820cb7ecad$var$formationPhase += 0.02 * dt;
    for(let i = $961a67820cb7ecad$var$enemies.length - 1; i >= 0; i--){
        const e = $961a67820cb7ecad$var$enemies[i];
        e.flap += 0.08 * dt;
        if (e.hurtFlash > 0) e.hurtFlash -= dtMs;
        if (e.state === 'flyin') {
            e.pathT += dt / 60 / e.pathDur;
            const t = Math.max(0, Math.min(1, e.pathT));
            const p = e.path;
            const nx = $961a67820cb7ecad$var$bezier(p.p0x, p.p1x, p.p2x, p.p3x, t);
            const ny = $961a67820cb7ecad$var$bezier(p.p0y, p.p1y, p.p2y, p.p3y, t);
            // face direction of travel
            e.angle = Math.atan2(ny - e.y, nx - e.x);
            e.x = nx;
            e.y = ny;
            if (e.pathT >= 1) {
                if (e.challenge) {
                    // Sweep complete: leave the screen (remove).
                    $961a67820cb7ecad$var$enemies.splice(i, 1);
                    continue;
                }
                e.state = 'formation';
                e.angle = 0;
            }
        } else if (e.state === 'formation') {
            const pos = $961a67820cb7ecad$var$slotPosition(e);
            e.x = pos.x;
            e.y = pos.y;
            e.angle = 0;
            // Formation fire (rare). Challenge enemies never shoot.
            if ($961a67820cb7ecad$var$gameState === 'playing' && !e.challenge && Math.random() < e.fireChance * dt * (0.6 + $961a67820cb7ecad$var$stage * 0.08)) $961a67820cb7ecad$var$fireEnemyBullet(e);
        } else if (e.state === 'dive') {
            e.diveT += dt / 60 / e.diveDur;
            const t = Math.min(1, e.diveT);
            const p = e.divePath;
            let nx = $961a67820cb7ecad$var$bezier(p.p0x, p.p1x, p.p2x, p.p3x, t);
            let ny = $961a67820cb7ecad$var$bezier(p.p0y, p.p1y, p.p2y, p.p3y, t);
            // Escorts trail their leader with a sideways offset (V shape).
            if (e.escortLeader && e.escortLeader.state === 'dive') nx += e.escortOffset;
            e.angle = Math.atan2(ny - e.y, nx - e.x) - Math.PI / 2;
            e.x = nx;
            e.y = ny;
            // Fire while diving.
            if (Math.random() < 0.012 * dt) $961a67820cb7ecad$var$fireEnemyBullet(e);
            if (t >= 1) {
                // Wrap to top and re-enter the formation slot.
                e.state = 'return';
                e.x = e.homeX + $961a67820cb7ecad$var$formationOffsetX();
                e.y = -e.h;
                e.returnT = 0;
            }
        } else if (e.state === 'return') {
            // Glide back down into the formation slot.
            const pos = $961a67820cb7ecad$var$slotPosition(e);
            const dx = pos.x - e.x;
            const dy = pos.y - e.y;
            e.x += dx * 0.08 * dt;
            e.y += dy * 0.08 * dt;
            e.angle = 0;
            if (Math.abs(dx) < 1.5 && Math.abs(dy) < 1.5) e.state = 'formation';
        } else if (e.state === 'capture') $961a67820cb7ecad$var$updateCaptureBoss(e, dt, dtMs);
    }
}
// Boss capture-dive state machine.
function $961a67820cb7ecad$var$updateCaptureBoss(boss, dt, dtMs) {
    boss.captureT += dtMs;
    if (boss.capturePhase === 'descend') {
        // Ease toward the target capture position.
        boss.x += (boss.captureTargetX - boss.x) * 0.05 * dt;
        boss.y += (boss.captureTargetY - boss.y) * 0.05 * dt;
        if (Math.abs(boss.y - boss.captureTargetY) < 3) {
            boss.capturePhase = 'beam';
            boss.captureT = 0;
            $961a67820cb7ecad$var$sfx.capture();
        }
    } else if (boss.capturePhase === 'beam') {
        // Open the beam over ~0.6s, hold ~1.4s, then close.
        const open = Math.min(1, boss.captureT / 600);
        boss.beam = open;
        // Check capture: player within the cone and not invulnerable.
        if (!$961a67820cb7ecad$var$player.captured && $961a67820cb7ecad$var$player.alive && $961a67820cb7ecad$var$tnow() > $961a67820cb7ecad$var$player.invulnUntil) {
            if ($961a67820cb7ecad$var$isPlayerInBeam(boss)) $961a67820cb7ecad$var$triggerCapture(boss);
        }
        if (boss.captureT > 2200) {
            boss.capturePhase = 'retreat';
            boss.beam = 0;
        }
    } else if (boss.capturePhase === 'retreat') {
        // Return to formation slot.
        const pos = $961a67820cb7ecad$var$slotPosition(boss);
        boss.x += (pos.x - boss.x) * 0.05 * dt;
        boss.y += (pos.y - boss.y) * 0.05 * dt;
        if (Math.abs(boss.y - pos.y) < 2 && Math.abs(boss.x - pos.x) < 2) {
            boss.isCapturing = false;
            // If it didn't capture anyone it returns to formation;
            // if it holds a fighter it stays in formation displaying it.
            boss.state = 'formation';
            $961a67820cb7ecad$var$captureActive = false;
            $961a67820cb7ecad$var$captureCooldown = 8000 + Math.random() * 5000;
        }
    }
}
// The tractor beam is a downward cone. Test if the player is inside it.
function $961a67820cb7ecad$var$isPlayerInBeam(boss) {
    const beamTopY = boss.y + boss.h;
    const beamBottomY = $961a67820cb7ecad$var$VH;
    if ($961a67820cb7ecad$var$PLAYER_Y < beamTopY) return false;
    const span = beamBottomY - beamTopY;
    const frac = ($961a67820cb7ecad$var$PLAYER_Y - beamTopY) / Math.max(1, span);
    const halfWidth = (4 + frac * 22) * boss.beam;
    return Math.abs($961a67820cb7ecad$var$player.x - boss.x) < halfWidth;
}
function $961a67820cb7ecad$var$triggerCapture(boss) {
    $961a67820cb7ecad$var$player.captured = true;
    boss.holdsCaptured = true;
    $961a67820cb7ecad$var$capturedHolder = boss;
    // Lose a life for the capture (authentic-ish: ship is taken).
    $961a67820cb7ecad$var$loseLife(true);
    $961a67820cb7ecad$var$sfx.capture();
// Visual: a captured ship will be drawn docked above the boss.
}
// ---- Enemy bullets --------------------------------------------------
function $961a67820cb7ecad$var$fireEnemyBullet(e) {
    // Aimed slightly toward the player.
    const dx = $961a67820cb7ecad$var$player.x - e.x;
    const dy = $961a67820cb7ecad$var$PLAYER_Y - e.y;
    const d = Math.max(1, Math.hypot(dx, dy));
    $961a67820cb7ecad$var$enemyBullets.push({
        x: e.x,
        y: e.y + e.h / 2,
        vx: dx / d * $961a67820cb7ecad$var$ENEMY_BULLET_SPEED * 0.5,
        vy: $961a67820cb7ecad$var$ENEMY_BULLET_SPEED
    });
}
// ---- Player ---------------------------------------------------------
// All gameplay timing uses performance.now (the audio clock is separate).
function $961a67820cb7ecad$var$tnow() {
    return $961a67820cb7ecad$var$simulationTime;
}
function $961a67820cb7ecad$var$updatePlayer(dt) {
    if (!$961a67820cb7ecad$var$player.alive) return;
    const moveLeft = $961a67820cb7ecad$var$keys['ArrowLeft'] || $961a67820cb7ecad$var$keys['a'] || $961a67820cb7ecad$var$keys['A'];
    const moveRight = $961a67820cb7ecad$var$keys['ArrowRight'] || $961a67820cb7ecad$var$keys['d'] || $961a67820cb7ecad$var$keys['D'];
    const half = $961a67820cb7ecad$var$player.dual ? 13 : 6;
    if (moveLeft) $961a67820cb7ecad$var$player.x = Math.max(half + 1, $961a67820cb7ecad$var$player.x - $961a67820cb7ecad$var$PLAYER_SPEED * dt);
    if (moveRight) $961a67820cb7ecad$var$player.x = Math.min($961a67820cb7ecad$var$VW - half - 1, $961a67820cb7ecad$var$player.x + $961a67820cb7ecad$var$PLAYER_SPEED * dt);
    if ($961a67820cb7ecad$var$keys[' '] || $961a67820cb7ecad$var$keys['Space']) $961a67820cb7ecad$var$tryShoot();
}
function $961a67820cb7ecad$var$tryShoot() {
    const t = $961a67820cb7ecad$var$tnow();
    if (t - $961a67820cb7ecad$var$lastShotTime < $961a67820cb7ecad$var$SHOT_COOLDOWN) return;
    const maxBullets = $961a67820cb7ecad$var$player.dual ? 4 : 2;
    if ($961a67820cb7ecad$var$bullets.length >= maxBullets) return;
    if ($961a67820cb7ecad$var$player.dual) {
        $961a67820cb7ecad$var$bullets.push({
            x: $961a67820cb7ecad$var$player.x - 7,
            y: $961a67820cb7ecad$var$PLAYER_Y,
            vy: -$961a67820cb7ecad$var$PLAYER_BULLET_SPEED
        });
        $961a67820cb7ecad$var$bullets.push({
            x: $961a67820cb7ecad$var$player.x + 7,
            y: $961a67820cb7ecad$var$PLAYER_Y,
            vy: -$961a67820cb7ecad$var$PLAYER_BULLET_SPEED
        });
    } else $961a67820cb7ecad$var$bullets.push({
        x: $961a67820cb7ecad$var$player.x,
        y: $961a67820cb7ecad$var$PLAYER_Y,
        vy: -$961a67820cb7ecad$var$PLAYER_BULLET_SPEED
    });
    $961a67820cb7ecad$var$shotsFired += $961a67820cb7ecad$var$player.dual ? 2 : 1;
    $961a67820cb7ecad$var$lastShotTime = t;
    $961a67820cb7ecad$var$sfx.shoot();
}
function $961a67820cb7ecad$var$loseLife(fromCapture) {
    // Dual fighter? Lose the second ship instead of a life.
    if ($961a67820cb7ecad$var$player.dual && !fromCapture) {
        $961a67820cb7ecad$var$player.dual = false;
        $961a67820cb7ecad$var$player.invulnUntil = $961a67820cb7ecad$var$tnow() + $961a67820cb7ecad$var$RESPAWN_INVULN;
        $961a67820cb7ecad$var$spawnExplosion($961a67820cb7ecad$var$player.x + 7, $961a67820cb7ecad$var$PLAYER_Y);
        $961a67820cb7ecad$var$sfx.explode();
        $961a67820cb7ecad$var$shake(220);
        return;
    }
    $961a67820cb7ecad$var$lives--;
    $961a67820cb7ecad$var$updateUI();
    $961a67820cb7ecad$var$spawnExplosion($961a67820cb7ecad$var$player.x, $961a67820cb7ecad$var$PLAYER_Y);
    $961a67820cb7ecad$var$sfx.explode();
    $961a67820cb7ecad$var$shake(320);
    if ($961a67820cb7ecad$var$lives <= 0) {
        $961a67820cb7ecad$var$player.alive = false;
        $961a67820cb7ecad$var$gameState = 'dying';
        $961a67820cb7ecad$var$dyingTimer = 900;
    } else {
        // Respawn after brief delay with invulnerability.
        $961a67820cb7ecad$var$player.alive = false;
        $961a67820cb7ecad$var$player.respawning = true;
        $961a67820cb7ecad$var$gameState = 'dying';
        $961a67820cb7ecad$var$dyingTimer = 700;
    }
}
let $961a67820cb7ecad$var$dyingTimer = 0;
function $961a67820cb7ecad$var$respawnPlayer() {
    $961a67820cb7ecad$var$player.alive = true;
    $961a67820cb7ecad$var$player.respawning = false;
    $961a67820cb7ecad$var$player.x = $961a67820cb7ecad$var$VW / 2;
    $961a67820cb7ecad$var$player.invulnUntil = $961a67820cb7ecad$var$tnow() + $961a67820cb7ecad$var$RESPAWN_INVULN;
    // Challenge stages run entirely in the 'flyin' state (that is where the
    // wave queue drains); returning to 'playing' there would soft-lock.
    $961a67820cb7ecad$var$gameState = $961a67820cb7ecad$var$isChallenge ? 'flyin' : 'playing';
}
// ---- Rescue / dual fighter ------------------------------------------
function $961a67820cb7ecad$var$rescueCapturedFighter(boss) {
    // The boss holding the captured ship was destroyed: free the ship.
    $961a67820cb7ecad$var$capturedHolder = null;
    $961a67820cb7ecad$var$player.captured = false;
    // Animate the freed ship docking next to the player => dual fighter.
    $961a67820cb7ecad$var$player.dual = true;
    $961a67820cb7ecad$var$player.invulnUntil = $961a67820cb7ecad$var$tnow() + 1000;
    $961a67820cb7ecad$var$sfx.rescue();
    $961a67820cb7ecad$var$spawnPopup($961a67820cb7ecad$var$player.x - 10, $961a67820cb7ecad$var$PLAYER_Y - 14, 'DUAL', '#28e0f0');
    // a few celebratory sparks
    for(let i = 0; i < 12; i++)$961a67820cb7ecad$var$spawnSpark($961a67820cb7ecad$var$player.x, $961a67820cb7ecad$var$PLAYER_Y, '#28e0f0');
}
// ---- Bullets update -------------------------------------------------
function $961a67820cb7ecad$var$updateBullets(dt) {
    for(let i = $961a67820cb7ecad$var$bullets.length - 1; i >= 0; i--){
        $961a67820cb7ecad$var$bullets[i].y += $961a67820cb7ecad$var$bullets[i].vy * dt;
        if ($961a67820cb7ecad$var$bullets[i].y < -6) $961a67820cb7ecad$var$bullets.splice(i, 1);
    }
    for(let i = $961a67820cb7ecad$var$enemyBullets.length - 1; i >= 0; i--){
        const b = $961a67820cb7ecad$var$enemyBullets[i];
        b.x += b.vx * dt;
        b.y += b.vy * dt;
        if (b.y > $961a67820cb7ecad$var$VH + 6 || b.x < -6 || b.x > $961a67820cb7ecad$var$VW + 6) $961a67820cb7ecad$var$enemyBullets.splice(i, 1);
    }
}
// ---- Particles / popups --------------------------------------------
function $961a67820cb7ecad$var$spawnExplosion(x, y) {
    $961a67820cb7ecad$var$particles.push({
        type: 'exp',
        x: x - 8,
        y: y - 8,
        frame: 0,
        t: 0
    });
}
function $961a67820cb7ecad$var$spawnSpark(x, y, color) {
    $961a67820cb7ecad$var$particles.push({
        type: 'spark',
        x: x,
        y: y,
        vx: (Math.random() - 0.5) * 3,
        vy: (Math.random() - 0.5) * 3,
        life: 1,
        color: color || '#ffe000',
        size: 1 + Math.random() * 2
    });
}
function $961a67820cb7ecad$var$updateParticles(dt) {
    for(let i = $961a67820cb7ecad$var$particles.length - 1; i >= 0; i--){
        const p = $961a67820cb7ecad$var$particles[i];
        if (p.type === 'exp') {
            p.t += dt;
            if (p.t > 4) {
                p.t = 0;
                p.frame++;
                if (p.frame >= $961a67820cb7ecad$var$EXP.length) $961a67820cb7ecad$var$particles.splice(i, 1);
            }
        } else {
            p.x += p.vx * dt;
            p.y += p.vy * dt;
            p.life -= 0.04 * dt;
            p.size *= 0.96;
            if (p.life <= 0) $961a67820cb7ecad$var$particles.splice(i, 1);
        }
    }
}
function $961a67820cb7ecad$var$spawnPopup(x, y, text, color) {
    $961a67820cb7ecad$var$popups.push({
        x: x,
        y: y,
        text: text,
        color: color || '#fff',
        life: 1
    });
}
function $961a67820cb7ecad$var$updatePopups(dt) {
    for(let i = $961a67820cb7ecad$var$popups.length - 1; i >= 0; i--){
        $961a67820cb7ecad$var$popups[i].y -= 0.3 * dt;
        $961a67820cb7ecad$var$popups[i].life -= 0.012 * dt;
        if ($961a67820cb7ecad$var$popups[i].life <= 0) $961a67820cb7ecad$var$popups.splice(i, 1);
    }
}
// ---- Collisions -----------------------------------------------------
function $961a67820cb7ecad$var$checkCollisions() {
    // Player bullets vs enemies.
    for(let bi = $961a67820cb7ecad$var$bullets.length - 1; bi >= 0; bi--){
        const b = $961a67820cb7ecad$var$bullets[bi];
        for(let ei = $961a67820cb7ecad$var$enemies.length - 1; ei >= 0; ei--){
            const e = $961a67820cb7ecad$var$enemies[ei];
            const hw = e.w / 2, hh = e.h / 2;
            if (b.x > e.x - hw && b.x < e.x + hw && b.y > e.y - hh && b.y < e.y + hh) {
                $961a67820cb7ecad$var$bullets.splice(bi, 1);
                $961a67820cb7ecad$var$shotsHit++;
                $961a67820cb7ecad$var$hitEnemy(e, ei);
                break;
            }
        }
    }
    // Enemy bullets vs player.
    if ($961a67820cb7ecad$var$player.alive && $961a67820cb7ecad$var$tnow() > $961a67820cb7ecad$var$player.invulnUntil) for(let i = $961a67820cb7ecad$var$enemyBullets.length - 1; i >= 0; i--){
        const b = $961a67820cb7ecad$var$enemyBullets[i];
        if ($961a67820cb7ecad$var$playerHitTest(b.x, b.y, 1)) {
            $961a67820cb7ecad$var$enemyBullets.splice(i, 1);
            $961a67820cb7ecad$var$loseLife(false);
            break;
        }
    }
    // Diving enemies vs player (collision).
    if ($961a67820cb7ecad$var$player.alive && $961a67820cb7ecad$var$tnow() > $961a67820cb7ecad$var$player.invulnUntil) for(let i = $961a67820cb7ecad$var$enemies.length - 1; i >= 0; i--){
        const e = $961a67820cb7ecad$var$enemies[i];
        if (e.state !== 'dive' && e.state !== 'capture' && !e.challenge) continue;
        if (e.state === 'capture') continue; // beam handled separately
        if ($961a67820cb7ecad$var$playerHitTest(e.x, e.y, e.w / 2)) {
            // Destroy the enemy too.
            $961a67820cb7ecad$var$spawnExplosion(e.x, e.y);
            $961a67820cb7ecad$var$enemies.splice(i, 1);
            $961a67820cb7ecad$var$loseLife(false);
            break;
        }
    }
}
// Test a point/radius against the player's hitbox (handles dual width).
function $961a67820cb7ecad$var$playerHitTest(x, y, r) {
    const half = $961a67820cb7ecad$var$player.dual ? 13 : 6;
    return x > $961a67820cb7ecad$var$player.x - half - r && x < $961a67820cb7ecad$var$player.x + half + r && y > $961a67820cb7ecad$var$PLAYER_Y - 7 - r && y < $961a67820cb7ecad$var$PLAYER_Y + 7 + r;
}
function $961a67820cb7ecad$var$hitEnemy(e, ei) {
    $961a67820cb7ecad$var$sfx.hit();
    if (e.kind === 'boss') {
        e.hp--;
        if (e.hp > 0) {
            // First hit: flip to damaged blue/purple flashing state.
            e.hurtFlash = 240;
            for(let i = 0; i < 4; i++)$961a67820cb7ecad$var$spawnSpark(e.x, e.y, '#c040ff');
            return;
        }
    }
    // Destroyed.
    $961a67820cb7ecad$var$destroyEnemy(e, ei);
}
function $961a67820cb7ecad$var$destroyEnemy(e, ei) {
    // Scoring: diving worth more; bosses escalate with escort count.
    let pts;
    const diving = e.state === 'dive' || e.state === 'capture' || e.challenge;
    if (e.kind === 'boss') {
        if (!diving) pts = 150;
        else {
            // Count escorts currently diving with this boss.
            let escorts = 0;
            for(let k = 0; k < $961a67820cb7ecad$var$enemies.length; k++)if ($961a67820cb7ecad$var$enemies[k].escortLeader === e && $961a67820cb7ecad$var$enemies[k].state === 'dive') escorts++;
            pts = escorts >= 2 ? 1600 : escorts === 1 ? 800 : 400;
        }
    } else pts = diving ? $961a67820cb7ecad$var$KIND[e.kind].scoreDive : $961a67820cb7ecad$var$KIND[e.kind].scoreForm;
    $961a67820cb7ecad$var$score += pts;
    if (e.challenge) $961a67820cb7ecad$var$challengeKills++;
    $961a67820cb7ecad$var$spawnPopup(e.x - 6, e.y, String(pts), e.kind === 'boss' ? '#28f0a0' : '#ffe000');
    $961a67820cb7ecad$var$spawnExplosion(e.x, e.y);
    $961a67820cb7ecad$var$sfx.explode();
    // If this boss held the captured fighter, free it (dual fighter!).
    if (e.holdsCaptured && $961a67820cb7ecad$var$capturedHolder === e) $961a67820cb7ecad$var$rescueCapturedFighter(e);
    if (e === $961a67820cb7ecad$var$capturedHolder) $961a67820cb7ecad$var$capturedHolder = null;
    if (e.isCapturing) {
        $961a67820cb7ecad$var$captureActive = false;
        $961a67820cb7ecad$var$captureCooldown = 6000;
    }
    $961a67820cb7ecad$var$enemies.splice(ei, 1);
    $961a67820cb7ecad$var$updateUI();
    // Stage clear?
    if (!$961a67820cb7ecad$var$isChallenge && $961a67820cb7ecad$var$enemies.length === 0 && $961a67820cb7ecad$var$flyInQueue.length === 0) $961a67820cb7ecad$var$stageClear();
}
function $961a67820cb7ecad$var$stageClear() {
    $961a67820cb7ecad$var$gameState = 'stage-clear';
    $961a67820cb7ecad$var$stageClearTimer = 1500;
    $961a67820cb7ecad$var$sfx.stageStart();
}
// ---- UI -------------------------------------------------------------
function $961a67820cb7ecad$var$updateUI() {
    if ($961a67820cb7ecad$var$score >= $961a67820cb7ecad$var$nextExtraLife) {
        $961a67820cb7ecad$var$lives++;
        $961a67820cb7ecad$var$nextExtraLife += 50000;
        $961a67820cb7ecad$var$spawnPopup($961a67820cb7ecad$var$player.x - 12, $961a67820cb7ecad$var$PLAYER_Y - 24, '1UP', '#28f0a0');
        $961a67820cb7ecad$var$sfx.rescue();
    }
    const accuracy = $961a67820cb7ecad$var$shotsFired ? Math.round($961a67820cb7ecad$var$shotsHit / $961a67820cb7ecad$var$shotsFired * 100) : 0;
    (0, $1FxTl.arcade).status(`Stage ${$961a67820cb7ecad$var$stage} \xb7 Best ${$961a67820cb7ecad$var$highScore.toLocaleString()} \xb7 Accuracy ${accuracy}% \xb7 Next life ${$961a67820cb7ecad$var$nextExtraLife.toLocaleString()}`, $961a67820cb7ecad$var$score / $961a67820cb7ecad$var$nextExtraLife * 100);
    document.getElementById('score').textContent = $961a67820cb7ecad$var$score;
    document.getElementById('lives').textContent = Math.max(0, $961a67820cb7ecad$var$lives);
    document.getElementById('wave').textContent = $961a67820cb7ecad$var$stage;
    if ($961a67820cb7ecad$var$score > $961a67820cb7ecad$var$highScore) {
        $961a67820cb7ecad$var$highScore = $961a67820cb7ecad$var$score;
        try {
            localStorage.setItem('galagaHighScore', String($961a67820cb7ecad$var$highScore));
        } catch (e) {}
    }
}
// ---- Screen shake ---------------------------------------------------
function $961a67820cb7ecad$var$shake(ms) {
    if ($961a67820cb7ecad$var$reduceMotion) return;
    $961a67820cb7ecad$var$shakeTime = Math.max($961a67820cb7ecad$var$shakeTime, ms);
}
// ---- Drawing --------------------------------------------------------
function $961a67820cb7ecad$var$drawPlayer() {
    if (!$961a67820cb7ecad$var$player.alive) return;
    // Blink while invulnerable.
    const invuln = $961a67820cb7ecad$var$tnow() < $961a67820cb7ecad$var$player.invulnUntil;
    if (invuln && Math.floor($961a67820cb7ecad$var$tnow() / 80) % 2 === 0) return;
    if ($961a67820cb7ecad$var$player.dual) {
        $961a67820cb7ecad$var$drawSprite($961a67820cb7ecad$var$SPR_PLAYER, $961a67820cb7ecad$var$PAL, $961a67820cb7ecad$var$player.x - 6 - 7, $961a67820cb7ecad$var$PLAYER_Y - 8, 1);
        $961a67820cb7ecad$var$drawSprite($961a67820cb7ecad$var$SPR_PLAYER, $961a67820cb7ecad$var$PAL, $961a67820cb7ecad$var$player.x - 6 + 7, $961a67820cb7ecad$var$PLAYER_Y - 8, 1);
    } else $961a67820cb7ecad$var$drawSprite($961a67820cb7ecad$var$SPR_PLAYER, $961a67820cb7ecad$var$PAL, $961a67820cb7ecad$var$player.x - 6, $961a67820cb7ecad$var$PLAYER_Y - 8, 1);
}
function $961a67820cb7ecad$var$drawEnemy(e) {
    const meta = $961a67820cb7ecad$var$KIND[e.kind];
    let grid, pal;
    const frame = Math.floor(e.flap) % 2 === 0 ? 0 : 1;
    if (e.kind === 'boss') {
        pal = $961a67820cb7ecad$var$PAL;
        if (e.hp <= 1 && meta.hp === 2) // Damaged: flash between hurt sprite and frames.
        grid = Math.floor($961a67820cb7ecad$var$tnow() / 120) % 2 === 0 ? $961a67820cb7ecad$var$SPR_BOSS_HURT : meta.frames[frame];
        else if (e.hurtFlash > 0) grid = $961a67820cb7ecad$var$SPR_BOSS_HURT;
        else grid = meta.frames[frame];
    } else {
        pal = $961a67820cb7ecad$var$PAL;
        grid = meta.frames[frame];
    }
    // Rotate diving enemies slightly to face travel direction. A boss that
    // holds a captured fighter keeps it docked above itself in every state
    // (formation AND dive), so it never blinks out mid-swoop.
    if ((e.state === 'dive' || e.state === 'flyin') && Math.abs(e.angle) > 0.05) {
        $961a67820cb7ecad$var$ctx.save();
        $961a67820cb7ecad$var$ctx.translate(Math.round(e.x), Math.round(e.y));
        $961a67820cb7ecad$var$ctx.rotate(e.angle);
        $961a67820cb7ecad$var$drawSprite(grid, pal, -e.w / 2, -e.h / 2, 1);
        if (e.holdsCaptured) $961a67820cb7ecad$var$drawSprite($961a67820cb7ecad$var$SPR_PLAYER, $961a67820cb7ecad$var$PAL_CAPTURED, -6, -e.h / 2 - 17, 1);
        $961a67820cb7ecad$var$ctx.restore();
    } else {
        $961a67820cb7ecad$var$drawSprite(grid, pal, e.x - e.w / 2, e.y - e.h / 2, 1);
        if (e.holdsCaptured) $961a67820cb7ecad$var$drawSprite($961a67820cb7ecad$var$SPR_PLAYER, $961a67820cb7ecad$var$PAL_CAPTURED, e.x - 6, e.y - e.h / 2 - 17, 1);
    }
}
function $961a67820cb7ecad$var$drawTractorBeam(e) {
    if (e.state !== 'capture' || e.beam <= 0) return;
    const topY = e.y + e.h / 2;
    const segments = 5;
    const maxHalf = 22 * e.beam;
    // Pulsing brightness.
    const pulse = 0.4 + 0.4 * Math.sin($961a67820cb7ecad$var$tnow() / 80);
    for(let s = 0; s < segments; s++){
        const f0 = s / segments;
        const f1 = (s + 1) / segments;
        const y0 = topY + f0 * ($961a67820cb7ecad$var$VH - topY);
        const y1 = topY + f1 * ($961a67820cb7ecad$var$VH - topY);
        const hw0 = 4 + f0 * (maxHalf - 4);
        const hw1 = 4 + f1 * (maxHalf - 4);
        // Alternating bands for the classic striped look.
        const bright = s % 2 === 0 ? pulse : pulse * 0.5;
        $961a67820cb7ecad$var$ctx.fillStyle = 'rgba(120,180,255,' + (0.25 + bright * 0.4) + ')';
        $961a67820cb7ecad$var$ctx.beginPath();
        $961a67820cb7ecad$var$ctx.moveTo(e.x - hw0, y0);
        $961a67820cb7ecad$var$ctx.lineTo(e.x + hw0, y0);
        $961a67820cb7ecad$var$ctx.lineTo(e.x + hw1, y1);
        $961a67820cb7ecad$var$ctx.lineTo(e.x - hw1, y1);
        $961a67820cb7ecad$var$ctx.closePath();
        $961a67820cb7ecad$var$ctx.fill();
    }
}
function $961a67820cb7ecad$var$drawBullets() {
    $961a67820cb7ecad$var$ctx.fillStyle = '#ffffff';
    for(let i = 0; i < $961a67820cb7ecad$var$bullets.length; i++){
        const b = $961a67820cb7ecad$var$bullets[i];
        $961a67820cb7ecad$var$ctx.fillRect(Math.round(b.x), Math.round(b.y) - 3, 1, 4);
        $961a67820cb7ecad$var$ctx.fillStyle = '#28e0f0';
        $961a67820cb7ecad$var$ctx.fillRect(Math.round(b.x), Math.round(b.y) - 1, 1, 2);
        $961a67820cb7ecad$var$ctx.fillStyle = '#ffffff';
    }
    // Enemy bullets: small yellow/orange darts.
    for(let i = 0; i < $961a67820cb7ecad$var$enemyBullets.length; i++){
        const b = $961a67820cb7ecad$var$enemyBullets[i];
        $961a67820cb7ecad$var$ctx.fillStyle = '#ffe000';
        $961a67820cb7ecad$var$ctx.fillRect(Math.round(b.x) - 1, Math.round(b.y), 2, 3);
        $961a67820cb7ecad$var$ctx.fillStyle = '#ff8000';
        $961a67820cb7ecad$var$ctx.fillRect(Math.round(b.x), Math.round(b.y) + 1, 1, 1);
    }
}
function $961a67820cb7ecad$var$drawParticles() {
    for(let i = 0; i < $961a67820cb7ecad$var$particles.length; i++){
        const p = $961a67820cb7ecad$var$particles[i];
        if (p.type === 'exp') $961a67820cb7ecad$var$drawSprite($961a67820cb7ecad$var$EXP[p.frame], $961a67820cb7ecad$var$PAL_EXP, p.x, p.y, 1);
        else {
            $961a67820cb7ecad$var$ctx.globalAlpha = Math.max(0, p.life);
            $961a67820cb7ecad$var$ctx.fillStyle = p.color;
            $961a67820cb7ecad$var$ctx.fillRect(Math.round(p.x), Math.round(p.y), Math.ceil(p.size), Math.ceil(p.size));
            $961a67820cb7ecad$var$ctx.globalAlpha = 1;
        }
    }
}
function $961a67820cb7ecad$var$drawPopups() {
    for(let i = 0; i < $961a67820cb7ecad$var$popups.length; i++){
        const p = $961a67820cb7ecad$var$popups[i];
        $961a67820cb7ecad$var$ctx.globalAlpha = Math.max(0, Math.min(1, p.life * 1.5));
        $961a67820cb7ecad$var$drawText(p.text, Math.round(p.x), Math.round(p.y), 1, p.color);
        $961a67820cb7ecad$var$ctx.globalAlpha = 1;
    }
}
// ---- Stage flags (number-flag badges) ------------------------------
// Flag denominations and colors, classic Galaga bottom-right markers.
const $961a67820cb7ecad$var$FLAG_DEFS = [
    {
        v: 50,
        col: '#28d028',
        txt: '50'
    },
    {
        v: 30,
        col: '#ff2020',
        txt: '30'
    },
    {
        v: 20,
        col: '#3858ff',
        txt: '20'
    },
    {
        v: 10,
        col: '#28e0f0',
        txt: '10'
    },
    {
        v: 5,
        col: '#ffe000',
        txt: '5'
    },
    {
        v: 1,
        col: '#ffffff',
        txt: '1'
    }
];
function $961a67820cb7ecad$var$drawStageFlags() {
    let remaining = $961a67820cb7ecad$var$stage;
    const flags = [];
    for(let i = 0; i < $961a67820cb7ecad$var$FLAG_DEFS.length; i++){
        while(remaining >= $961a67820cb7ecad$var$FLAG_DEFS[i].v){
            flags.push($961a67820cb7ecad$var$FLAG_DEFS[i]);
            remaining -= $961a67820cb7ecad$var$FLAG_DEFS[i].v;
            if (flags.length > 12) break; // safety cap
        }
        if (flags.length > 12) break;
    }
    // Draw from bottom-right going left.
    let fx = $961a67820cb7ecad$var$VW - 2;
    const fy = $961a67820cb7ecad$var$VH - 9;
    for(let i = 0; i < flags.length; i++){
        const f = flags[i];
        fx -= 9;
        // little flag body
        $961a67820cb7ecad$var$ctx.fillStyle = f.col;
        $961a67820cb7ecad$var$ctx.fillRect(fx, fy, 8, 7);
        $961a67820cb7ecad$var$ctx.fillStyle = '#000';
        // number in 3px-ish, draw with small font scaled to fit
        $961a67820cb7ecad$var$drawText(f.txt, fx + 1, fy + 1, 1, '#000');
    }
}
// ---- Lives icons ----------------------------------------------------
function $961a67820cb7ecad$var$drawLivesIcons() {
    const n = Math.max(0, $961a67820cb7ecad$var$lives - ($961a67820cb7ecad$var$gameState === 'dying' ? 0 : 0));
    for(let i = 0; i < Math.min(n, 6); i++)$961a67820cb7ecad$var$drawSprite($961a67820cb7ecad$var$SPR_PLAYER, $961a67820cb7ecad$var$PAL, 2 + i * 12, $961a67820cb7ecad$var$VH - 17, 1);
}
// ---- HUD (in-canvas arcade text) -----------------------------------
let $961a67820cb7ecad$var$oneUpBlink = 0;
function $961a67820cb7ecad$var$drawHUD() {
    $961a67820cb7ecad$var$oneUpBlink += 1;
    // "1UP" blinks; score beneath it.
    if (Math.floor($961a67820cb7ecad$var$oneUpBlink / 30) % 2 === 0) $961a67820cb7ecad$var$drawText('1UP', 12, 2, 1, '#ff2020');
    const sc = String($961a67820cb7ecad$var$score);
    $961a67820cb7ecad$var$drawText(sc, 12, 10, 1, '#ffffff');
    $961a67820cb7ecad$var$drawTextCentered('HIGH SCORE', 2, 1, '#ff2020');
    const hs = String($961a67820cb7ecad$var$highScore);
    $961a67820cb7ecad$var$drawText(hs, Math.round(($961a67820cb7ecad$var$VW - $961a67820cb7ecad$var$textWidth(hs, 1)) / 2), 10, 1, '#ffffff');
    // Stage number top-right.
    $961a67820cb7ecad$var$drawText('ST', $961a67820cb7ecad$var$VW - 30, 2, 1, '#28e0f0');
    $961a67820cb7ecad$var$drawText(String($961a67820cb7ecad$var$stage), $961a67820cb7ecad$var$VW - 14, 2, 1, '#ffe000');
}
// ---- Main draw ------------------------------------------------------
function $961a67820cb7ecad$var$draw() {
    // Apply scale transform so all logical coords render at 2x.
    $961a67820cb7ecad$var$ctx.setTransform(1, 0, 0, 1, 0, 0);
    $961a67820cb7ecad$var$ctx.fillStyle = '#000';
    $961a67820cb7ecad$var$ctx.fillRect(0, 0, $961a67820cb7ecad$var$canvas.width, $961a67820cb7ecad$var$canvas.height);
    // Screen shake offset (disabled under reduced motion).
    let ox = 0, oy = 0;
    if ($961a67820cb7ecad$var$shakeTime > 0 && !$961a67820cb7ecad$var$reduceMotion) {
        ox = (Math.random() - 0.5) * 4;
        oy = (Math.random() - 0.5) * 4;
    }
    $961a67820cb7ecad$var$ctx.setTransform($961a67820cb7ecad$var$SCALE, 0, 0, $961a67820cb7ecad$var$SCALE, ox * $961a67820cb7ecad$var$SCALE, oy * $961a67820cb7ecad$var$SCALE);
    $961a67820cb7ecad$var$drawStars();
    // World objects.
    for(let i = 0; i < $961a67820cb7ecad$var$enemies.length; i++)if ($961a67820cb7ecad$var$enemies[i].state === 'capture') $961a67820cb7ecad$var$drawTractorBeam($961a67820cb7ecad$var$enemies[i]);
    for(let i = 0; i < $961a67820cb7ecad$var$enemies.length; i++)$961a67820cb7ecad$var$drawEnemy($961a67820cb7ecad$var$enemies[i]);
    $961a67820cb7ecad$var$drawBullets();
    $961a67820cb7ecad$var$drawParticles();
    $961a67820cb7ecad$var$drawPlayer();
    $961a67820cb7ecad$var$drawPopups();
    // HUD overlays.
    $961a67820cb7ecad$var$drawHUD();
    $961a67820cb7ecad$var$drawLivesIcons();
    $961a67820cb7ecad$var$drawStageFlags();
    // Banners.
    if ($961a67820cb7ecad$var$stageBannerTimer > 0) {
        if ($961a67820cb7ecad$var$isChallenge) {
            $961a67820cb7ecad$var$drawTextCentered('CHALLENGING', $961a67820cb7ecad$var$VH / 2 - 14, 1, '#28e0f0');
            $961a67820cb7ecad$var$drawTextCentered('STAGE', $961a67820cb7ecad$var$VH / 2 - 4, 1, '#28e0f0');
        } else $961a67820cb7ecad$var$drawTextCentered('STAGE ' + $961a67820cb7ecad$var$stage, $961a67820cb7ecad$var$VH / 2 - 6, 1, '#28e0f0');
    }
    if ($961a67820cb7ecad$var$perfectTimer > 0) {
        $961a67820cb7ecad$var$drawTextCentered('PERFECT !', $961a67820cb7ecad$var$VH / 2 - 6, 2, '#ffe000');
        $961a67820cb7ecad$var$drawTextCentered('10000 PTS', $961a67820cb7ecad$var$VH / 2 + 8, 1, '#ffffff');
    }
    if ($961a67820cb7ecad$var$gameState === 'gameover') $961a67820cb7ecad$var$drawTextCentered('GAME OVER', $961a67820cb7ecad$var$VH / 2 - 6, 1, '#ff2020');
}
// ---- Main loop ------------------------------------------------------
let $961a67820cb7ecad$var$lastTime = performance.now();
let $961a67820cb7ecad$var$accumulator = 0;
function $961a67820cb7ecad$var$simulate() {
    const dtMs = 1000 / 60;
    const dt = 1;
    $961a67820cb7ecad$var$simulationTime += dtMs;
    // Timers.
    if ($961a67820cb7ecad$var$shakeTime > 0) $961a67820cb7ecad$var$shakeTime -= dtMs;
    if ($961a67820cb7ecad$var$stageBannerTimer > 0) $961a67820cb7ecad$var$stageBannerTimer -= dtMs;
    if ($961a67820cb7ecad$var$perfectTimer > 0) $961a67820cb7ecad$var$perfectTimer -= dtMs;
    if ($961a67820cb7ecad$var$captureCooldown > 0) $961a67820cb7ecad$var$captureCooldown -= dtMs;
    $961a67820cb7ecad$var$updateStars(dt);
    $961a67820cb7ecad$var$updateParticles(dt);
    $961a67820cb7ecad$var$updatePopups(dt);
    if ($961a67820cb7ecad$var$gameState === 'flyin') {
        $961a67820cb7ecad$var$updatePlayer(dt);
        $961a67820cb7ecad$var$updateEnemies(dt, dtMs);
        $961a67820cb7ecad$var$updateBullets(dt);
        $961a67820cb7ecad$var$checkCollisions();
        $961a67820cb7ecad$var$updateFlyIn(dt, dtMs);
    } else if ($961a67820cb7ecad$var$gameState === 'playing') {
        $961a67820cb7ecad$var$updatePlayer(dt);
        $961a67820cb7ecad$var$updateEnemies(dt, dtMs);
        $961a67820cb7ecad$var$updateBullets(dt);
        $961a67820cb7ecad$var$checkCollisions();
        // Schedule dives.
        $961a67820cb7ecad$var$diveTimer += dtMs;
        const diveInterval = Math.max(700, 2200 - $961a67820cb7ecad$var$stage * 120);
        if ($961a67820cb7ecad$var$diveTimer > diveInterval && !$961a67820cb7ecad$var$isChallenge) {
            $961a67820cb7ecad$var$diveTimer = 0;
            $961a67820cb7ecad$var$pickDivers();
        }
    } else if ($961a67820cb7ecad$var$gameState === 'dying') {
        $961a67820cb7ecad$var$updateEnemies(dt, dtMs);
        $961a67820cb7ecad$var$updateBullets(dt);
        $961a67820cb7ecad$var$dyingTimer -= dtMs;
        if ($961a67820cb7ecad$var$dyingTimer <= 0) {
            if ($961a67820cb7ecad$var$lives <= 0) $961a67820cb7ecad$var$doGameOver();
            else $961a67820cb7ecad$var$respawnPlayer();
        }
    } else if ($961a67820cb7ecad$var$gameState === 'stage-clear') {
        $961a67820cb7ecad$var$updateEnemies(dt, dtMs);
        $961a67820cb7ecad$var$stageClearTimer -= dtMs;
        if ($961a67820cb7ecad$var$stageClearTimer <= 0) {
            $961a67820cb7ecad$var$stage++;
            $961a67820cb7ecad$var$beginStage();
        }
    }
}
function $961a67820cb7ecad$var$loop(t) {
    const elapsed = Math.min(80, t - $961a67820cb7ecad$var$lastTime);
    $961a67820cb7ecad$var$lastTime = t;
    if (!(0, $1FxTl.arcade).paused) {
        $961a67820cb7ecad$var$accumulator += elapsed;
        while($961a67820cb7ecad$var$accumulator >= 1000 / 60){
            $961a67820cb7ecad$var$simulate();
            $961a67820cb7ecad$var$accumulator -= 1000 / 60;
        }
        $961a67820cb7ecad$var$draw();
        $961a67820cb7ecad$var$updateUI();
    } else $961a67820cb7ecad$var$accumulator = 0;
    requestAnimationFrame($961a67820cb7ecad$var$loop);
}
// ---- Game over ------------------------------------------------------
function $961a67820cb7ecad$var$doGameOver() {
    $961a67820cb7ecad$var$gameState = 'gameover';
    $961a67820cb7ecad$var$updateUI();
    document.getElementById('finalScore').textContent = $961a67820cb7ecad$var$score;
    document.getElementById('run-stats').textContent = `Stage ${$961a67820cb7ecad$var$stage} \xb7 ${$961a67820cb7ecad$var$shotsFired} shots \xb7 ${$961a67820cb7ecad$var$shotsFired ? Math.round($961a67820cb7ecad$var$shotsHit / $961a67820cb7ecad$var$shotsFired * 100) : 0}% accuracy`;
    document.getElementById('gameOverScreen').classList.remove('hidden');
    $961a67820cb7ecad$var$updateMobileControlsVisibility();
}
// ---- Start / restart ------------------------------------------------
function $961a67820cb7ecad$var$startGame() {
    $961a67820cb7ecad$var$resumeAudio();
    $961a67820cb7ecad$var$score = 0;
    $961a67820cb7ecad$var$shotsFired = $961a67820cb7ecad$var$shotsHit = 0;
    $961a67820cb7ecad$var$nextExtraLife = 20000;
    $961a67820cb7ecad$var$lastShotTime = -$961a67820cb7ecad$var$SHOT_COOLDOWN;
    $961a67820cb7ecad$var$lives = 3;
    $961a67820cb7ecad$var$stage = 1;
    $961a67820cb7ecad$var$bullets = [];
    $961a67820cb7ecad$var$enemyBullets = [];
    $961a67820cb7ecad$var$particles = [];
    $961a67820cb7ecad$var$popups = [];
    $961a67820cb7ecad$var$player.x = $961a67820cb7ecad$var$VW / 2;
    $961a67820cb7ecad$var$player.alive = true;
    $961a67820cb7ecad$var$player.dual = false;
    $961a67820cb7ecad$var$player.captured = false;
    $961a67820cb7ecad$var$player.invulnUntil = 0;
    $961a67820cb7ecad$var$capturedHolder = null;
    $961a67820cb7ecad$var$captureActive = false;
    document.getElementById('startScreen').classList.add('hidden');
    document.getElementById('gameOverScreen').classList.add('hidden');
    $961a67820cb7ecad$var$updateMobileControlsVisibility();
    $961a67820cb7ecad$var$beginStage();
}
// ---- Mobile controls visibility ------------------------------------
function $961a67820cb7ecad$var$updateMobileControlsVisibility() {
    const mobileControls = document.getElementById('mobileControls');
    const startScreen = document.getElementById('startScreen');
    const gameOverScreen = document.getElementById('gameOverScreen');
    const dialogVisible = !startScreen.classList.contains('hidden') || !gameOverScreen.classList.contains('hidden');
    if (dialogVisible) mobileControls.classList.add('hidden');
    else mobileControls.classList.remove('hidden');
}
// ---- Input ----------------------------------------------------------
document.addEventListener('keydown', function(e) {
    $961a67820cb7ecad$var$keys[e.key] = true;
    if (e.key === ' ' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
});
document.addEventListener('keyup', function(e) {
    $961a67820cb7ecad$var$keys[e.key] = false;
});
document.getElementById('startBtn').addEventListener('click', $961a67820cb7ecad$var$startGame);
document.getElementById('restartBtn').addEventListener('click', $961a67820cb7ecad$var$startGame);
// Touch buttons drive the same `keys` object as the keyboard.
function $961a67820cb7ecad$var$setupTouchButton(button, keyName) {
    const activate = function(e) {
        e.preventDefault();
        $961a67820cb7ecad$var$keys[keyName] = true;
        button.classList.add('active');
        $961a67820cb7ecad$var$resumeAudio();
    };
    const deactivate = function(e) {
        e.preventDefault();
        $961a67820cb7ecad$var$keys[keyName] = false;
        button.classList.remove('active');
    };
    (0, $1FxTl.bindPointer)(button, ()=>activate({
            preventDefault () {}
        }), ()=>deactivate({
            preventDefault () {}
        }));
}
$961a67820cb7ecad$var$setupTouchButton(document.getElementById('btnLeft'), 'ArrowLeft');
$961a67820cb7ecad$var$setupTouchButton(document.getElementById('btnRight'), 'ArrowRight');
$961a67820cb7ecad$var$setupTouchButton(document.getElementById('btnFire'), ' ');
// Prevent page scroll while playing on touch.
document.getElementById('gameContainer').addEventListener('touchmove', function(e) {
    if ($961a67820cb7ecad$var$gameState !== 'start' && $961a67820cb7ecad$var$gameState !== 'gameover') e.preventDefault();
}, {
    passive: false
});
// Resume audio on first canvas touch.
$961a67820cb7ecad$var$canvas.addEventListener('touchstart', function() {
    $961a67820cb7ecad$var$resumeAudio();
}, {
    passive: true
});
// ---- Boot -----------------------------------------------------------
(0, $1FxTl.arcade).mount({
    title: 'Galaga',
    help: "Move with \u2190 \u2192 or A/D. Hold Space to fire. Destroy a diving boss holding your fighter to recover it and fly dual. Earn an extra life at 20,000, then every 50,000 points. P pauses; M toggles sound.",
    active: ()=>![
            'start',
            'gameover'
        ].includes($961a67820cb7ecad$var$gameState),
    clearInput: ()=>Object.keys($961a67820cb7ecad$var$keys).forEach((key)=>{
            $961a67820cb7ecad$var$keys[key] = false;
        }),
    restart: $961a67820cb7ecad$var$startGame,
    onResume: ()=>{
        $961a67820cb7ecad$var$lastTime = performance.now();
        $961a67820cb7ecad$var$accumulator = 0;
    }
});
$961a67820cb7ecad$var$initStars();
$961a67820cb7ecad$var$updateUI();
$961a67820cb7ecad$var$updateMobileControlsVisibility();
requestAnimationFrame($961a67820cb7ecad$var$loop);


//# sourceMappingURL=galaga.d0e7289f.js.map
